import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPQantVoc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6097_800)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.0836 14.8336C12.9298 15.9874 11.4598 16.7732 9.8595 17.0915C8.25915 17.4098 6.60035 17.2464 5.09286 16.622C3.58537 15.9976 2.2969 14.9402 1.39038 13.5835C0.483854 12.2268 1.00494e-07 10.6317 0 9C-1.00494e-07 7.36831 0.483854 5.77326 1.39038 4.41655C2.2969 3.05984 3.58537 2.00242 5.09286 1.378C6.60035 0.753575 8.25915 0.590197 9.85949 0.908525C11.4598 1.22685 12.9298 2.01259 14.0836 3.16637L9.84099 7.40901C8.96231 8.28769 8.96231 9.71231 9.84099 10.591L14.0836 14.8336Z",
			fill: "#32C8DC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M15.4393 3.31066L10.8107 7.93934C10.2249 8.52513 10.2249 9.47487 10.8107 10.0607L15.4393 14.6893C16.3843 15.6343 18 14.965 18 13.6287V4.37132C18 3.03496 16.3843 2.36572 15.4393 3.31066Z",
			fill: "#005AFF"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6097_800",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgPQantVoc;
